<h2 mat-dialog-title>Conectar correo</h2>

<mat-dialog-content class="connect-mail-account-dialog" [formGroup]="form">
  <p>
    Los correos que lleguen a este buzón se analizarán automáticamente. Los que se detecten como
    gasto se guardarán en "Facturas sin contabilizar" junto al resto de tus facturas.
  </p>
  <div class="alert alert-warning" role="alert">
    La cuenta de correo debe ser obligatoriamente de <strong>Gmail</strong> y tener activada la
    <strong>verificación en dos pasos</strong>. Además, deberás crear una
    <a href="https://myaccount.google.com/apppasswords" target="_blank" rel="noopener noreferrer">contraseña de aplicación</a>
    para poder conectarla.
  </div>

  <p class="text-muted">
    <small>Nota: algunas cuentas de Outlook/Microsoft 365 de empresa no admiten esta conexión por política del propio Microsoft, aunque la contraseña sea correcta.</small>
  </p>

  <mat-form-field class="w-100">
    <input matInput placeholder="Email" formControlName="email" type="email">
  </mat-form-field>

  <mat-form-field class="w-100">
    <input matInput placeholder="Contraseña" formControlName="password" type="password">
  </mat-form-field>
  <small class="form-text text-muted field-help">Con verificación en dos pasos, usa una contraseña de aplicación.</small>

  <mat-form-field class="w-100">
    <input matInput placeholder="Servidor IMAP (ej. imap.gmail.com)" formControlName="imapHost">
  </mat-form-field>

  <mat-form-field class="w-100">
    <input matInput placeholder="Puerto IMAP" formControlName="imapPort" type="number">
  </mat-form-field>

  <mat-form-field class="w-100">
    <input matInput [matDatepicker]="picker" placeholder="Importar desde (opcional)" formControlName="fechaDesde">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <small class="form-text text-muted field-help">Vacío = solo correos a partir de hoy.</small>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()" [disabled]="saving">Cancelar</button>
  <button mat-raised-button color="primary" (click)="conectar()" [disabled]="form.invalid || saving">
    {{ saving ? 'Conectando...' : 'Conectar' }}
  </button>
</mat-dialog-actions>
